import React, { useEffect, createRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLazyQuery, useMutation } from '@apollo/client';
import Papa from 'papaparse';

import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';


import { ADMIN_UPDATE_LINKS, ADMIN_UPDATE_PRODUCTS } from "../utils/mutations";

function parseCsv(f) {
  return new Promise((resolve, reject) =>
    Papa.parse(f, {complete: resolve, error: reject})
  );
}

function AdminProducts() {
  const dispatch = useDispatch();

  const [showProductsToast, setShowProductsToast] = useState(false);

  const [updateProducts, { data: productsData, loading: productsLoading, error: productsError }] =
    useMutation(ADMIN_UPDATE_PRODUCTS);

  const [productsSelected, setProductsSelected] = useState(null);

  function handleProductsFile(e) {
    parseCsv(productsSelected)
      .then(({data}) => {
        if (data[0][4] === 'SKU') {
          delete data[0];
          const products = data.filter(r => r[0])
            .map(r => ({
              name: r[0].trim(),
              description: r[1].trim(),
              category_slug: r[2].trim(),
              image: r[3],
              sku: r[4].trim(),
              price_usd: Number(r[5]),
              weight: r[6].trim(),
              active: Boolean(r[7]),
              in_stock: Boolean(r[8])
            }));
          return updateProducts({ variables: {products} })
            .then(() => setShowProductsToast(true));
        } else {
          alert("You seem to have picked the wrong file.\n\nIt should have column headers ['Name', 'Description', 'Category Slug', 'Image Filename', 'SKU', 'Price USD', 'Weight', 'Active', 'In Stock']");
        }
      });
  }

  return (
    <div>
        <nav className="breadcrumb"><Link to="/admin">Admin</Link></nav>

        <h2>Admin Products</h2>

        <Form>

          <Form.Group className="mb-3">
            <Form.Label>Update Products Links from CSV</Form.Label>
            <Form.Control className="mb-2" type="file" accept=".csv,text/csv"
              onInput={e => setProductsSelected(e.nativeEvent.target.files[0])}></Form.Control>
            <button disabled={! productsSelected} type="button" className="btn btn-warning"
              onClick={handleProductsFile}>Update Products</button>
          </Form.Group>

        </Form>

        <Toast onClose={() => setShowProductsToast(false)} show={showProductsToast} delay={15000} autohide>
          <Toast.Header>
            <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
            <strong className="me-auto">Notice</strong>
          </Toast.Header>
          <Toast.Body>Product database has been updated from your file.</Toast.Body>
        </Toast>
    </div>
  );
}

export default AdminProducts;
